import { jsx as _jsx } from "react/jsx-runtime";
import { motion } from 'framer-motion';
import { usePrefersReducedMotion } from './usePrefersReducedMotion';
export function RevealOnScroll({ children, delay = 0, className, y = 20, }) {
    const reduced = usePrefersReducedMotion();
    if (reduced) {
        return (_jsx(motion.div, { className: className, initial: { opacity: 0 }, whileInView: { opacity: 1 }, viewport: { once: true, margin: '-100px' }, transition: { duration: 0.3, delay }, children: children }));
    }
    return (_jsx(motion.div, { className: className, initial: { opacity: 0, y }, whileInView: { opacity: 1, y: 0 }, viewport: { once: true, margin: '-100px' }, transition: { duration: 0.7, ease: [0.22, 1, 0.36, 1], delay }, children: children }));
}
